import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { Chip } from "primereact/chip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";
import Divider from "../../../components/menu/Divider";
import { formatCpfOrCnpj } from "../../../utils/ValidationUtils";

export default function ProtestoCartorio({
  data
}: {
  data: any
}) {
  const { t } = useTranslation();

  const getBaseData = (item: any) => item?.resultado || item?.Pacote_Regional;
  const hasData = data && data.length > 0 && data.some((item: any) => {
    const baseData = getBaseData(item);
    return baseData && baseData.identificacao?.status !== 'nada_consta';
  });

  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return (
      <div className={className}>
        {hasData ? (
          <span style={{ color: '#C70039', fontSize: '1.5rem' }} className="pi pi-exclamation-triangle">
            <span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>
              {t('Protesto Nacional')}
            </span>
          </span>
        ) : (
          <span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>
            {t('Protesto Nacional')}
          </span>
        )}
      </div>
    );
  }

  const formatCurrency = (value: any) => {
    if (value === null || value === undefined) return '';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  };

  const identificacoes = hasData
    ? data.map((item: any) => getBaseData(item)?.identificacao).filter((identificacao: any) => !!identificacao)
    : [];
  const resumo = identificacoes.reduce((acc: any, identificacao: any) => ({
    vlr_total_protestado: acc.vlr_total_protestado + (identificacao.vlr_total_protestado || 0),
    qtd_total_protesto: acc.qtd_total_protesto + (identificacao.qtd_total_protesto || 0),
    qtd_cartorios_distintos: acc.qtd_cartorios_distintos + (identificacao.qtd_cartorios_distintos || 0),
    qtd_cidades_distintas: acc.qtd_cidades_distintas + (identificacao.qtd_cidades_distintas || 0),
  }), { vlr_total_protestado: 0, qtd_total_protesto: 0, qtd_cartorios_distintos: 0, qtd_cidades_distintas: 0 });
  const primeiraIdentificacao = identificacoes[0];

  return (
    <Panel headerTemplate={headerTemplate}>
      {!hasData && (<NadaConsta />)}
      {hasData && primeiraIdentificacao && (
        <div>
          <div className="flex-consulta flex-wrap gap-3">
            <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }}>
              <div className="flex-consulta justify-content-between gap-5">
                <div className="flex-consulta flex-column gap-1">
                  <span style={{ color: 'white' }} className="text-sm">{t('Valor Total Protestado')}</span>
                  <span style={{ color: 'white' }} className="font-bold text-lg">{formatCurrency(resumo.vlr_total_protestado)}</span>
                </div>
                <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                  <i className="pi pi-money-bill" />
                </span>
              </div>
            </Card>

            <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }}>
              <div className="flex-consulta justify-content-between gap-5">
                <div className="flex-consulta flex-column gap-1">
                  <span style={{ color: 'white' }} className="text-sm">{t('Qtd. Total Protestos')}</span>
                  <span style={{ color: 'white' }} className="font-bold text-lg">{resumo.qtd_total_protesto}</span>
                </div>
                <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                  <i className="pi pi-file" />
                </span>
              </div>
            </Card>

            <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }}>
              <div className="flex-consulta justify-content-between gap-5">
                <div className="flex-consulta flex-column gap-1">
                  <span style={{ color: 'white' }} className="text-sm">{t('Cartórios Distintos')}</span>
                  <span style={{ color: 'white' }} className="font-bold text-lg">{resumo.qtd_cartorios_distintos}</span>
                </div>
                <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                  <i className="pi pi-building" />
                </span>
              </div>
            </Card>

            <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }}>
              <div className="flex-consulta justify-content-between gap-5">
                <div className="flex-consulta flex-column gap-1">
                  <span style={{ color: 'white' }} className="text-sm">{t('Cidades Distintas')}</span>
                  <span style={{ color: 'white' }} className="font-bold text-lg">{resumo.qtd_cidades_distintas}</span>
                </div>
                <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                  <i className="pi pi-map-marker" />
                </span>
              </div>
            </Card>
          </div>
          <br></br>
          <div className="grid">
            <div className="col p-fluid flex flex-wrap">
              <div style={{ width: "100%" }}>
                <label className="label-dados">{t('documento')}</label>
                <Chip style={{ width: "100%" }} label={formatCpfOrCnpj(primeiraIdentificacao.documento)} />
              </div>
            </div>
            <div className="col p-fluid flex flex-wrap">
              <div style={{ width: "100%" }}>
                <label className="label-dados">{t('cnae devedor')}</label>
                <Chip style={{ width: "100%" }} label={primeiraIdentificacao.cnae_devedor || 'Não Informado'} />
              </div>
            </div>
          </div>
          <br></br>
        </div>
      )}
      {hasData && data.map((item: any, index: number) => {
        const baseData = getBaseData(item);
        if (!baseData) return null;
        const cartorios = baseData.cartorios || [];

        return (
          <div key={index}>
            {cartorios.map((cartorio: any, idx: number) => {
              return (
                <div key={idx}>
                  <div className="grid">
                    <div className="col p-fluid flex flex-wrap">
                      <div style={{ width: "100%" }}>
                        <label className="label-dados">{t('UF')}</label>
                        <Chip style={{ width: "100%" }} label={cartorio.nome_uf || cartorio.codigo_uf} />
                      </div>
                    </div>
                    <div className="col p-fluid flex flex-wrap">
                      <div style={{ width: "100%" }}>
                        <label className="label-dados">{t('Cidade')}</label>
                        <Chip style={{ width: "100%" }} label={cartorio.nome_municipio || cartorio.codigo_cidade} />
                      </div>
                    </div>
                    {cartorio.codigo_cartorio && (
                      <div className="col p-fluid flex flex-wrap">
                        <div style={{ width: "100%" }}>
                          <label className="label-dados">{t('Código Cartório')}</label>
                          <Chip style={{ width: "100%" }} label={cartorio.codigo_cartorio || 'Não Informado'} />
                        </div>
                      </div>
                    )}
                  </div>

                  {cartorio.nome_cartorio && (
                    <div className="grid">
                      <div className="col p-fluid flex flex-wrap">
                        <div style={{ width: "100%" }}>
                          <label className="label-dados">{t('Nome do Cartório')}</label>
                          <Chip style={{ width: "100%" }} label={cartorio.nome_cartorio} />
                        </div>
                      </div>
                    </div>
                  )}

                  {(cartorio.telefone_cartorio || cartorio.endereco_cartorio) && (
                    <div className="grid">
                      {cartorio.telefone_cartorio && (
                        <div className="col p-fluid flex flex-wrap">
                          <div style={{ width: "100%" }}>
                            <label className="label-dados">{t('Telefone')}</label>
                            <Chip style={{ width: "100%" }} label={cartorio.telefone_cartorio} />
                          </div>
                        </div>
                      )}
                      {cartorio.endereco_cartorio && (
                        <div className="col p-fluid flex flex-wrap">
                          <div style={{ width: "100%" }}>
                            <label className="label-dados">{t('Endereço')}</label>
                            <Chip style={{ width: "100%" }} label={cartorio.endereco_cartorio} />
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {(cartorio.qtd_total_protesto !== undefined || cartorio.vlr_total_protestado !== undefined) && (
                    <div className="grid">
                      {cartorio.qtd_total_protesto !== undefined && (
                        <div className="col p-fluid flex flex-wrap">
                          <div style={{ width: "100%" }}>
                            <label className="label-dados">{t('Qtd. Protestos (Cartório)')}</label>
                            <Chip style={{ width: "100%" }} label={cartorio.qtd_total_protesto} />
                          </div>
                        </div>
                      )}
                      {cartorio.vlr_total_protestado !== undefined && (
                        <div className="col p-fluid flex flex-wrap">
                          <div style={{ width: "100%" }}>
                            <label className="label-dados">{t('Valor Protestado (Cartório)')}</label>
                            <Chip style={{ width: "100%" }} label={formatCurrency(cartorio.vlr_total_protestado)} />
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {cartorio.titulos && cartorio.titulos.length > 0 && (
                    <>
                      <br></br>
                      <DataTable size="small" value={cartorio.titulos} tableStyle={{ minWidth: '50rem' }}>
                        <Column field="data" header={t('data')} body={(rowData) => {
                          const val = rowData.data;
                          if (!val || typeof val !== 'string') return val || "";
                          const trimmed = val.trim();
                          const isDatePattern = /^(\d{2,4}[-/]\d{2}[-/]\d{2,4})/.test(trimmed);
                          const isParsable = !isNaN(Date.parse(trimmed));
                          return (isDatePattern || isParsable) ? val : "";
                        }}></Column>
                        <Column field="valor" header={t('valor')} body={(rowData) => {
                          return formatCurrency(rowData.valor);
                        }}></Column>
                      </DataTable>
                      <br></br>
                      <br></br>
                      <br></br>
                    </>
                  )}
                </div>
              );
            })}
            <Divider></Divider>
            <br></br>
          </div>
        );
      })}
    </Panel>
  )
}
